export var hasValidPrice = function hasValidPrice(price) {
  if (price && price !== 0 && price !== '0' && price !== '' && price !== null) {
    return true;
  } else {
    return false;
  }
};